/**
 * This file is automatically generated by the `words/create-dict.ts` script.
 * Do not edit it directly. If the dictionary files are edited use
 * `pnpm script:make-dictionary` script to update this file.
 */

/** Random words to select from when generating a slug */
export const words = {
  adjectives: [
    'abiding',
    'able',
    'abundant',
    'academic',
    'acceptable',
    'accessible',
    'acclaimed',
    'accomplished',
    'accurate',
    'acerbic',
    'active',
    'adamant',
    'adaptable',
    'additional',
    'admirable',
    'adored',
    'advanced',
    'adventurous',
    'aesthetic',
    'affable',
    'affirmative',
    'agile',
    'agreeable',
    'airy',
    'alacritous',
    'alert',
    'alluring',
    'amazing',
    'amiable',
    'amicable',
    'ample',
    'amusing',
    'ancient',
    'angelic',
    'animated',
    'antique',
    'anxious',
    'appealing',
    'appetizing',
    'apt',
    'ardent',
    'aromatic',
    'artful',
    'articulate',
    'artistic',
    'assured',
    'astounding',
    'astute',
    'attractive',
    'audible',
    'austere',
    'authentic',
    'available',
    'balanced',
    'balmy',
    'bashful',
    'beaming',
    'beautiful',
    'beneficial',
    'benevolent',
    'best',
    'better',
    'blissful',
    'blithe',
    'blithesome',
    'bold',
    'bouncy',
    'breezy',
    'bright',
    'brilliant',
    'brisk',
    'bubbly',
    'bucolic',
    'buoyant',
    'burgeoning',
    'calm',
    'candid',
    'capable',
    'capricious',
    'captivating',
    'carefree',
    'careful',
    'caring',
    'casual',
    'cautious',
    'celebrated',
    'celestial',
    'cerebral',
    'certain',
    'charming',
    'cheerful',
    'cheery',
    'chic',
    'chimerical',
    'chivalrous',
    'circumspect',
    'clandestine',
    'classic',
    'classical',
    'clean',
    'clear',
    'clement',
    'clever',
    'close',
    'coherent',
    'colorful',
    'colossal',
    'comely',
    'comfortable',
    'comforting',
    'commendable',
    'compelling',
    'composed',
    'concise',
    'confident',
    'congenial',
    'conscientious',
    'considerate',
    'consistent',
    'constant',
    'constructive',
    'contemporary',
    'continuous',
    'convincing',
    'convivial',
    'cool',
    'cooperative',
    'cordial',
    'cosmic',
    'courageous',
    'courteous',
    'creative',
    'credible',
    'crisp',
    'cultivated',
    'cultured',
    'curious',
    'cute',
    'daring',
    'dauntless',
    'dazzling',
    'debonair',
    'decent',
    'decorative',
    'decorous',
    'deft',
    'delicate',
    'delightful',
    'demure',
    'dependable',
    'descriptive',
    'desirable',
    'detailed',
    'determined',
    'devoted',
    'dexterous',
    'different',
    'dignified',
    'diligent',
    'discerning',
    'disciplined',
    'discreet',
    'distinct',
    'distinctive',
    'distinguished',
    'diverse',
    'divine',
    'dynamic',
    'eager',
    'earnest',
    'earthy',
    'easygoing',
    'ebullient',
    'eclectic',
    'ecstatic',
    'edgy',
    'edifying',
    'effervescent',
    'efficacious',
    'efficient',
    'effulgent',
    'electrifying',
    'elegant',
    'elegiac',
    'elevated',
    'eloquent',
    'eminent',
    'emphatic',
    'empowered',
    'empowering',
    'enchanting',
    'endearing',
    'energetic',
    'engaging',
    'enlightened',
    'enlivened',
    'enraptured',
    'enterprising',
    'entertaining',
    'enthralling',
    'enticing',
    'entrancing',
    'enviable',
    'epic',
    'equable',
    'equanimous',
    'equitable',
    'essential',
    'esteemed',
    'ethereal',
    'ethical',
    'euphoric',
    'even',
    'evocative',
    'excellent',
    'exceptional',
    'exciting',
    'exemplary',
    'exhilarating',
    'exotic',
    'exquisite',
    'extended',
    'extensive',
    'extraordinary',
    'extroverted',
    'exuberant',
    'fabulous',
    'fair',
    'faithful',
    'familiar',
    'fanciful',
    'fancy',
    'fantastic',
    'fascinating',
    'fast',
    'fastidious',
    'favorable',
    'feasible',
    'felicitous',
    'fervent',
    'fervid',
    'festive',
    'fine',
    'firm',
    'first',
    'flamboyant',
    'flawless',
    'flexible',
    'flourishing',
    'flowery',
    'focused',
    'fond',
    'fortunate',
    'fragrant',
    'free',
    'fresh',
    'friendly',
    'fruitful',
    'fulgent',
    'fun',
    'functional',
    'funky',
    'futuristic',
    'gallant',
    'generous',
    'genial',
    'genteel',
    'gentle',
    'genuine',
    'giddy',
    'gifted',
    'glad',
    'gleaming',
    'glimmering',
    'glistening',
    'glittering',
    'glorious',
    'glossy',
    'glowing',
    'golden',
    'good',
    'gossamer',
    'graceful',
    'gracious',
    'grand',
    'grandiose',
    'grateful',
    'great',
    'green',
    'gregarious',
    'groovy',
    'grounded',
    'gustatory',
    'halcyon',
    'handsome',
    'happy',
    'hardy',
    'harmonious',
    'heartening',
    'heartfelt',
    'heartwarming',
    'hearty',
    'heavenly',
    'helpful',
    'heroic',
    'high',
    'honest',
    'honorable',
    'hopeful',
    'hospitable',
    'humble',
    'humorous',
    'hushed',
    'ideal',
    'idyllic',
    'illuminating',
    'illustrious',
    'imaginary',
    'imaginative',
    'immaculate',
    'impartial',
    'impeccable',
    'impressive',
    'inborn',
    'incandescent',
    'incisive',
    'inclusive',
    'incomparable',
    'incredible',
    'indefatigable',
    'independent',
    'industrious',
    'ineffable',
    'infinite',
    'influential',
    'informal',
    'ingenious',
    'inimitable',
    'innate',
    'innocent',
    'innovative',
    'inquisitive',
    'insightful',
    'insouciant',
    'inspired',
    'inspiring',
    'instant',
    'instinctive',
    'instinctual',
    'integral',
    'intelligent',
    'intense',
    'interested',
    'interesting',
    'intermediate',
    'intimate',
    'intoxicating',
    'intrepid',
    'intricate',
    'intuitive',
    'inventive',
    'invigorating',
    'invincible',
    'inviting',
    'iridescent',
    'irrefutable',
    'jaunty',
    'jocular',
    'jolly',
    'jovial',
    'joyful',
    'joyous',
    'jubilant',
    'judicious',
    'just',
    'keen',
    'kind',
    'kindly',
    'knightly',
    'knowledgeable',
    'laudable',
    'lavish',
    'leading',
    'legendary',
    'light',
    'lighthearted',
    'likable',
    'limber',
    'lithe',
    'lively',
    'logical',
    'lovely',
    'loving',
    'lucid',
    'luculent',
    'luminous',
    'luscious',
    'lush',
    'lustrous',
    'magnetic',
    'magnificent',
    'majestic',
    'malleable',
    'manageable',
    'marked',
    'marvelous',
    'mature',
    'meaningful',
    'measured',
    'mellifluous',
    'mellow',
    'melodic',
    'memorable',
    'mercurial',
    'meritorious',
    'methodical',
    'meticulous',
    'mindful',
    'miraculous',
    'mirthful',
    'modern',
    'modest',
    'moral',
    'motivated',
    'moving',
    'multifaceted',
    'mystical',
    'natural',
    'navigable',
    'neat',
    'necessary',
    'new',
    'next',
    'nifty',
    'nimble',
    'nippy',
    'noble',
    'nonpareil',
    'notable',
    'noteworthy',
    'novel',
    'nuanced',
    'numinous',
    'nurturing',
    'nutritious',
    'objective',
    'obliging',
    'observant',
    'obvious',
    'occasional',
    'oceanic',
    'odd',
    'omnipotent',
    'oneiric',
    'opalescent',
    'open',
    'opportune',
    'optimal',
    'optimistic',
    'opulent',
    'orderly',
    'organic',
    'original',
    'ornate',
    'otherworldly',
    'outstanding',
    'overjoyed',
    'pacific',
    'palatable',
    'palpable',
    'parallel',
    'paramount',
    'passionate',
    'pastoral',
    'patient',
    'peaceful',
    'peppy',
    'perceptive',
    'perfect',
    'perky',
    'persevering',
    'persistent',
    'personable',
    'pertinent',
    'phenomenal',
    'philosophical',
    'picturesque',
    'plausible',
    'pleasant',
    'pliable',
    'plucky',
    'plush',
    'poetic',
    'polished',
    'popular',
    'positive',
    'potent',
    'practical',
    'pragmatic',
    'precious',
    'precise',
    'premier',
    'prestigious',
    'prime',
    'principled',
    'pristine',
    'productive',
    'proficient',
    'profound',
    'progressive',
    'prolific',
    'prompt',
    'proper',
    'proud',
    'prudent',
    'punctilious',
    'punctual',
    'pure',
    'quaint',
    'qualified',
    'quantitative',
    'quick',
    'quiet',
    'radiant',
    'rational',
    'raw',
    'real',
    'reasonable',
    'recent',
    'redolent',
    'refined',
    'reflective',
    'refreshing',
    'refulgent',
    'regal',
    'regular',
    'reliable',
    'remarkable',
    'renewed',
    'resilient',
    'resolute',
    'resourceful',
    'respectable',
    'respectful',
    'resplendent',
    'responsible',
    'responsive',
    'reverent',
    'rewarding',
    'rhythmic',
    'rich',
    'riveting',
    'robust',
    'romantic',
    'rustic',
    'sacred',
    'sagacious',
    'sage',
    'salient',
    'salubrious',
    'sanctified',
    'sane',
    'sanguine',
    'satisfying',
    'savory',
    'savvy',
    'scenic',
    'scholarly',
    'scintillating',
    'scrupulous',
    'secure',
    'sedate',
    'select',
    'selfless',
    'sensible',
    'sensitive',
    'serendipitous',
    'serene',
    'sharp',
    'shimmering',
    'shining',
    'silky',
    'silvery',
    'simple',
    'sincere',
    'skillful',
    'sleek',
    'slender',
    'slick',
    'small',
    'smart',
    'smooth',
    'snappy',
    'snug',
    'sober',
    'soft',
    'solid',
    'soothing',
    'sophisticated',
    'soulful',
    'sparkling',
    'special',
    'spectacular',
    'spirited',
    'splendid',
    'spontaneous',
    'sporting',
    'sporty',
    'sprightly',
    'spry',
    'stable',
    'stalwart',
    'stately',
    'steadfast',
    'steady',
    'stellar',
    'stimulating',
    'stirring',
    'strategic',
    'striking',
    'strong',
    'studious',
    'stunning',
    'sturdy',
    'stylish',
    'suave',
    'subdued',
    'sublime',
    'subtle',
    'successful',
    'succinct',
    'sumptuous',
    'sunny',
    'superb',
    'superior',
    'supple',
    'supportive',
    'supreme',
    'sure',
    'surefooted',
    'surprising',
    'surreal',
    'sustainable',
    'swanky',
    'sweet',
    'swift',
    'sympathetic',
    'synergetic',
    'systematic',
    'tactful',
    'tactile',
    'tasteful',
    'teeming',
    'tenable',
    'tenacious',
    'tender',
    'terrific',
    'thankful',
    'thorough',
    'thoughtful',
    'thrifty',
    'thrilling',
    'thriving',
    'tidy',
    'timeless',
    'tireless',
    'tolerant',
    'tonic',
    'tough',
    'tranquil',
    'transcendent',
    'transparent',
    'tremendous',
    'trendy',
    'trim',
    'true',
    'trusting',
    'trustworthy',
    'truthful',
    'ultimate',
    'ultramarine',
    'unabashed',
    'unassuming',
    'unbeatable',
    'unbiased',
    'uncommon',
    'understated',
    'unerring',
    'unique',
    'upbeat',
    'uplifting',
    'urbane',
    'useful',
    'valiant',
    'valid',
    'valuable',
    'venerable',
    'veracious',
    'verdant',
    'versatile',
    'vibrant',
    'victorious',
    'vigilant',
    'vigorous',
    'virtuosic',
    'virtuous',
    'visionary',
    'vivacious',
    'vivid',
    'warm',
    'warmhearted',
    'welcoming',
    'well',
    'whimsical',
    'wholehearted',
    'wholesome',
    'willing',
    'winning',
    'winsome',
    'wise',
    'wistful',
    'witty',
    'wonderful',
    'wondrous',
    'wretched',
    'wry',
    'xenial',
    'yare',
    'youthful',
    'zany',
    'zealous',
    'zestful',
    'zesty',
    'zippy',
  ],
  nouns: [
    'acacia',
    'acorn',
    'acre',
    'admiral',
    'adventure',
    'aerobics',
    'afternoon',
    'aircraft',
    'airline',
    'airplane',
    'airport',
    'alfalfa',
    'almond',
    'alpaca',
    'altitude',
    'aluminum',
    'amaryllis',
    'amber',
    'ambrosia',
    'amethyst',
    'anemone',
    'anise',
    'antelope',
    'apartment',
    'apex',
    'apothecary',
    'apple',
    'apricot',
    'aquarium',
    'aqueduct',
    'arbor',
    'arch',
    'archipelago',
    'arctic',
    'arena',
    'argon',
    'aroma',
    'arrow',
    'artichoke',
    'asteroid',
    'astronaut',
    'astronomy',
    'atmosphere',
    'atom',
    'atrium',
    'aurora',
    'autumn',
    'avalanche',
    'avenue',
    'aviary',
    'avocado',
    'azalea',
    'azure',
    'baboon',
    'backpack',
    'bacon',
    'badger',
    'bagel',
    'baguette',
    'bakery',
    'balcony',
    'balloon',
    'bamboo',
    'banana',
    'banjo',
    'barley',
    'barnacle',
    'barometer',
    'barrel',
    'basil',
    'basin',
    'basket',
    'bassoon',
    'bat',
    'bath',
    'bay',
    'beach',
    'beacon',
    'bead',
    'beam',
    'bean',
    'beanie',
    'bear',
    'beaver',
    'beech',
    'beehive',
    'beetle',
    'begonia',
    'berry',
    'bicycle',
    'binoculars',
    'birch',
    'biscuit',
    'bison',
    'blackberry',
    'blade',
    'blanket',
    'blimp',
    'blizzard',
    'blossom',
    'blueberry',
    'boat',
    'bobcat',
    'bobsled',
    'bog',
    'bonfire',
    'bongo',
    'bonnet',
    'borage',
    'border',
    'borough',
    'bouquet',
    'bowl',
    'branch',
    'brass',
    'breeze',
    'brewery',
    'bridge',
    'broccoli',
    'brook',
    'broom',
    'broth',
    'bubble',
    'bucket',
    'bud',
    'buffalo',
    'buffet',
    'buggy',
    'bulb',
    'bull',
    'bullfinch',
    'bumblebee',
    'bunny',
    'burrito',
    'bush',
    'butter',
    'butterfly',
    'buttermilk',
    'buzzard',
    'cabin',
    'cabinet',
    'cactus',
    'cafe',
    'cafeteria',
    'cage',
    'cairn',
    'cake',
    'calculator',
    'calendar',
    'camel',
    'camera',
    'campfire',
    'campground',
    'campus',
    'canal',
    'canary',
    'candle',
    'candy',
    'canoe',
    'canopy',
    'cantaloupe',
    'canyon',
    'cape',
    'capital',
    'cappuccino',
    'capsule',
    'caravan',
    'carbon',
    'cardamom',
    'cardinal',
    'cargo',
    'caribou',
    'carnation',
    'carnival',
    'carousel',
    'carriage',
    'carrot',
    'cart',
    'cartwheel',
    'cascade',
    'cashew',
    'cassava',
    'casserole',
    'castle',
    'catamaran',
    'caterpillar',
    'cauliflower',
    'cave',
    'cavern',
    'cedar',
    'ceiling',
    'celery',
    'cellar',
    'cello',
    'cement',
    'cereal',
    'chameleon',
    'chamomile',
    'channel',
    'chant',
    'chapel',
    'charcoal',
    'charm',
    'chart',
    'chateau',
    'checkers',
    'cheddar',
    'cheese',
    'cheesecake',
    'cheetah',
    'chef',
    'cherry',
    'chestnut',
    'chiffon',
    'chili',
    'chimney',
    'chipmunk',
    'chives',
    'chocolate',
    'chord',
    'chowder',
    'chrysalis',
    'chutney',
    'cider',
    'cilantro',
    'cinnamon',
    'circle',
    'circuit',
    'circus',
    'cistern',
    'citadel',
    'citrus',
    'city',
    'clam',
    'clarinet',
    'clementine',
    'cliff',
    'climate',
    'cloak',
    'clock',
    'closet',
    'cloud',
    'clover',
    'clown',
    'coast',
    'cobalt',
    'cobbler',
    'cobra',
    'cocoa',
    'coconut',
    'coffee',
    'coil',
    'coin',
    'cola',
    'coliseum',
    'comet',
    'compass',
    'compost',
    'computer',
    'concert',
    'condor',
    'cone',
    'constellation',
    'continent',
    'cookie',
    'copper',
    'coral',
    'cord',
    'coriander',
    'cork',
    'corn',
    'cornucopia',
    'cosmos',
    'cottage',
    'cotton',
    'couch',
    'cougar',
    'country',
    'countryside',
    'court',
    'courtyard',
    'cove',
    'cow',
    'cowbell',
    'coyote',
    'crab',
    'cradle',
    'cranberry',
    'crater',
    'crayon',
    'cream',
    'creek',
    'crest',
    'cricket',
    'crocus',
    'croissant',
    'crop',
    'crossroad',
    'crow',
    'crown',
    'cruise',
    'crystal',
    'cube',
    'cucumber',
    'cuisine',
    'cumin',
    'cumulus',
    'cupboard',
    'cupcake',
    'currant',
    'current',
    'curry',
    'curtain',
    'cushion',
    'custard',
    'cutlery',
    'cycle',
    'cyclone',
    'cypress',
    'daffodil',
    'dahlia',
    'daisy',
    'dale',
    'dam',
    'dandelion',
    'dashboard',
    'date',
    'dawn',
    'daylight',
    'dazzle',
    'deck',
    'deer',
    'delta',
    'denim',
    'desert',
    'desk',
    'dessert',
    'dew',
    'dewdrop',
    'diamond',
    'diary',
    'dictionary',
    'diesel',
    'dill',
    'dinghy',
    'dinosaur',
    'diploma',
    'dirigible',
    'dish',
    'dock',
    'dolphin',
    'dome',
    'donkey',
    'donut',
    'door',
    'dormitory',
    'dove',
    'dowel',
    'downpour',
    'downtown',
    'dragon',
    'dragonfly',
    'drawer',
    'dream',
    'dress',
    'dresser',
    'driftwood',
    'drill',
    'drink',
    'drone',
    'droplet',
    'drum',
    'dryer',
    'duck',
    'duckling',
    'dugout',
    'dune',
    'durian',
    'dusk',
    'dust',
    'eagle',
    'earth',
    'earthquake',
    'easel',
    'east',
    'eclipse',
    'ecology',
    'ecosystem',
    'eel',
    'egg',
    'eggplant',
    'elder',
    'electricity',
    'element',
    'elevator',
    'elm',
    'emerald',
    'empire',
    'enamel',
    'encyclopedia',
    'engine',
    'engineer',
    'entrance',
    'envelope',
    'environment',
    'enzyme',
    'epicenter',
    'equator',
    'equipment',
    'escalator',
    'espalier',
    'estuary',
    'eucalyptus',
    'evening',
    'evergreen',
    'expedition',
    'explorer',
    'express',
    'fabric',
    'facade',
    'factory',
    'falcon',
    'fall',
    'farm',
    'farmer',
    'farmhouse',
    'feather',
    'fern',
    'ferry',
    'festival',
    'fiber',
    'field',
    'fig',
    'finch',
    'fir',
    'firefly',
    'firework',
    'fish',
    'fjord',
    'flag',
    'flamingo',
    'flannel',
    'flash',
    'flask',
    'flavor',
    'fleece',
    'flight',
    'float',
    'flock',
    'flood',
    'floor',
    'flounder',
    'flour',
    'flower',
    'fluff',
    'flute',
    'fog',
    'foliage',
    'food',
    'forest',
    'fork',
    'formula',
    'fort',
    'fortress',
    'fountain',
    'fox',
    'fragrance',
    'frame',
    'freeway',
    'freezer',
    'frost',
    'fruit',
    'fuel',
    'furnace',
    'furniture',
    'galaxy',
    'gallery',
    'galley',
    'gallon',
    'gallop',
    'game',
    'garden',
    'gargoyle',
    'garland',
    'garlic',
    'garnet',
    'gate',
    'gateway',
    'gazebo',
    'gazelle',
    'gear',
    'geese',
    'gelatin',
    'gem',
    'geyser',
    'gherkin',
    'ginger',
    'giraffe',
    'glacier',
    'glade',
    'glass',
    'glider',
    'globe',
    'gloss',
    'glove',
    'glow',
    'glucose',
    'glue',
    'goat',
    'goblet',
    'goldfish',
    'golf',
    'gondola',
    'goose',
    'gorge',
    'gorilla',
    'gourd',
    'grain',
    'granola',
    'grape',
    'grapefruit',
    'graph',
    'grass',
    'grasshopper',
    'gravel',
    'gravity',
    'greenhouse',
    'grid',
    'griffin',
    'grill',
    'grotto',
    'grove',
    'guava',
    'guide',
    'guitar',
    'gull',
    'gumball',
    'gumdrop',
    'gummy',
    'habitat',
    'hacksaw',
    'hail',
    'hall',
    'hallway',
    'halo',
    'halter',
    'hamlet',
    'hammock',
    'hamster',
    'handball',
    'harbor',
    'hardwood',
    'harmonica',
    'harmony',
    'harp',
    'harvest',
    'hatchling',
    'haven',
    'hawk',
    'hawthorn',
    'hazelnut',
    'headlight',
    'headset',
    'heather',
    'heaven',
    'hedge',
    'helicopter',
    'heliotrope',
    'helix',
    'helium',
    'hemp',
    'herb',
    'heron',
    'hibiscus',
    'highway',
    'hill',
    'hillside',
    'hinge',
    'hippopotamus',
    'hive',
    'hobby',
    'hockey',
    'holly',
    'home',
    'hominy',
    'honey',
    'honeycomb',
    'honeydew',
    'hood',
    'hoof',
    'hook',
    'horizon',
    'horn',
    'hornet',
    'horse',
    'horseradish',
    'hose',
    'hotel',
    'hovercraft',
    'hub',
    'hubcap',
    'huckleberry',
    'hull',
    'hummingbird',
    'hurricane',
    'hyacinth',
    'hydrogen',
    'hyena',
    'hyphen',
    'ibis',
    'ice',
    'icicle',
    'igloo',
    'iguana',
    'incense',
    'inlet',
    'inn',
    'insect',
    'instrument',
    'intersection',
    'interstate',
    'island',
    'isthmus',
    'ivy',
    'jacket',
    'jade',
    'jaguar',
    'jam',
    'jasmine',
    'jasper',
    'jazz',
    'jeep',
    'jelly',
    'jellyfish',
    'jersey',
    'jet',
    'jetty',
    'jewel',
    'jigsaw',
    'journey',
    'juniper',
    'jupiter',
    'jute',
    'kale',
    'kangaroo',
    'karaoke',
    'kayak',
    'keel',
    'kelp',
    'kennel',
    'kernel',
    'kettle',
    'key',
    'keyboard',
    'khaki',
    'kilt',
    'kiosk',
    'kite',
    'kitten',
    'kiwi',
    'knot',
    'koala',
    'koi',
    'kumquat',
    'laboratory',
    'lace',
    'ladder',
    'ladle',
    'lagoon',
    'lake',
    'lamb',
    'lamp',
    'land',
    'landmark',
    'landscape',
    'lane',
    'lantern',
    'larch',
    'lark',
    'larkspur',
    'laser',
    'latitude',
    'lattice',
    'laurel',
    'lava',
    'lavender',
    'lawn',
    'lead',
    'leaf',
    'leash',
    'leather',
    'leek',
    'lemon',
    'lemonade',
    'lens',
    'leopard',
    'lettuce',
    'level',
    'library',
    'licorice',
    'light',
    'lighthouse',
    'lightning',
    'lilac',
    'lily',
    'lime',
    'limestone',
    'linen',
    'linguine',
    'lion',
    'liquid',
    'lizard',
    'llama',
    'loaf',
    'lobster',
    'locomotive',
    'locust',
    'lodge',
    'loft',
    'log',
    'longitude',
    'loom',
    'lotus',
    'lounge',
    'lullaby',
    'lumber',
    'luminance',
    'lunch',
    'lute',
    'lychee',
    'lynx',
    'macadamia',
    'macaroni',
    'macaw',
    'machine',
    'mackerel',
    'macrame',
    'magazine',
    'magnet',
    'magnolia',
    'magpie',
    'mahogany',
    'mail',
    'mailbox',
    'maize',
    'malt',
    'mammal',
    'mammoth',
    'mandarin',
    'mango',
    'mangrove',
    'mansion',
    'mantis',
    'maple',
    'marble',
    'marina',
    'market',
    'marmalade',
    'marmot',
    'marquee',
    'marsh',
    'marshmallow',
    'martini',
    'mask',
    'masonry',
    'mast',
    'mat',
    'matrix',
    'mattress',
    'mayonnaise',
    'meadow',
    'meal',
    'melon',
    'mercury',
    'meridian',
    'meteor',
    'mica',
    'microphone',
    'microscope',
    'midnight',
    'mile',
    'milk',
    'milkshake',
    'millennium',
    'millet',
    'mineral',
    'mint',
    'minute',
    'mirror',
    'mist',
    'mitten',
    'moat',
    'mobile',
    'moccasin',
    'mockingbird',
    'modem',
    'module',
    'mohair',
    'moisture',
    'mole',
    'molecule',
    'molasses',
    'moment',
    'monarch',
    'monastery',
    'mongoose',
    'monitor',
    'monkey',
    'monolith',
    'monsoon',
    'monument',
    'moon',
    'moose',
    'morning',
    'morocco',
    'mosaic',
    'mosque',
    'mosquito',
    'moss',
    'motel',
    'moth',
    'mother',
    'mountain',
    'mouse',
    'mousse',
    'movie',
    'muffin',
    'mulberry',
    'mule',
    'multimedia',
    'mural',
    'museum',
    'mushroom',
    'music',
    'muskmelon',
    'mustard',
    'mustang',
    'nacre',
    'nail',
    'napkin',
    'narcissus',
    'nation',
    'nature',
    'nebula',
    'nectar',
    'nectarine',
    'needle',
    'neighborhood',
    'neon',
    'nest',
    'network',
    'neutron',
    'newt',
    'nickel',
    'nightingale',
    'nitrogen',
    'noodle',
    'north',
    'notebook',
    'nougat',
    'nova',
    'novel',
    'nozzle',
    'nucleus',
    'nugget',
    'number',
    'numeral',
    'nurse',
    'nursery',
    'nutmeg',
    'nutrient',
    'nylon',
    'nymph',
    'oak',
    'oasis',
    'oatmeal',
    'oboe',
    'observatory',
    'obsidian',
    'ocean',
    'octagon',
    'octopus',
    'odometer',
    'office',
    'oil',
    'okra',
    'olive',
    'omega',
    'omelet',
    'onion',
    'opera',
    'orange',
    'orchard',
    'orchestra',
    'orchid',
    'oregano',
    'organ',
    'origami',
    'oriole',
    'ornament',
    'osmium',
    'osprey',
    'ostrich',
    'otter',
    'outrigger',
    'oval',
    'oven',
    'overture',
    'owl',
    'oxygen',
    'oyster',
    'ozone',
    'package',
    'packet',
    'paddle',
    'padlock',
    'page',
    'pagoda',
    'pail',
    'paint',
    'pajama',
    'palace',
    'palette',
    'palm',
    'pamphlet',
    'pan',
    'panda',
    'pansy',
    'panther',
    'papaya',
    'paper',
    'paprika',
    'papyrus',
    'parachute',
    'parade',
    'paradise',
    'paraffin',
    'parcel',
    'parchment',
    'park',
    'parrot',
    'parsley',
    'partridge',
    'passage',
    'passenger',
    'passion',
    'pasta',
    'pastel',
    'pastry',
    'patch',
    'path',
    'patio',
    'pavilion',
    'paw',
    'peach',
    'peacock',
    'peak',
    'peanut',
    'pear',
    'pearl',
    'pebble',
    'pecan',
    'pedal',
    'pelican',
    'pen',
    'pencil',
    'penguin',
    'peninsula',
    'penny',
    'peony',
    'pepper',
    'perch',
    'percussion',
    'perfume',
    'petal',
    'petroleum',
    'pewter',
    'pheasant',
    'phoenix',
    'phosphorus',
    'photograph',
    'piano',
    'piccolo',
    'pickup',
    'picnic',
    'picture',
    'pie',
    'pier',
    'pigeon',
    'pigment',
    'pillar',
    'pillow',
    'pilot',
    'pimento',
    'pin',
    'pine',
    'pineapple',
    'pinecone',
    'pinwheel',
    'pioneer',
    'pipe',
    'pistachio',
    'pitch',
    'pizza',
    'planet',
    'plank',
    'plant',
    'plantation',
    'plaster',
    'plastic',
    'plate',
    'platform',
    'platinum',
    'plaza',
    'pliers',
    'plough',
    'plum',
    'plume',
    'plywood',
    'pocket',
    'poem',
    'poet',
    'point',
    'pollen',
    'polo',
    'polyester',
    'pond',
    'pony',
    'pool',
    'popcorn',
    'poplar',
    'poppy',
    'popsicle',
    'porch',
    'porcupine',
    'port',
    'porter',
    'post',
    'postage',
    'poster',
    'pot',
    'potato',
    'pottery',
    'pouch',
    'powder',
    'prairie',
    'prawn',
    'precipitation',
    'pretzel',
    'primrose',
    'prism',
    'processor',
    'produce',
    'propeller',
    'protein',
    'prune',
    'pudding',
    'puffin',
    'pulley',
    'pulse',
    'puma',
    'pump',
    'pumpkin',
    'puppet',
    'puppy',
    'pyramid',
    'quail',
    'quartz',
    'quasar',
    'queen',
    'quiche',
    'quill',
    'quilt',
    'quince',
    'quinoa',
    'rabbit',
    'raccoon',
    'race',
    'racket',
    'radar',
    'radiator',
    'radio',
    'radish',
    'raft',
    'railroad',
    'railway',
    'rain',
    'rainbow',
    'raisin',
    'rake',
    'rambler',
    'ramp',
    'ranch',
    'raspberry',
    'raven',
    'ravioli',
    'ray',
    'realm',
    'recipe',
    'record',
    'recorder',
    'rectangle',
    'redwood',
    'reef',
    'refrigerator',
    'region',
    'reindeer',
    'relay',
    'reptile',
    'reservoir',
    'resort',
    'restaurant',
    'rhinestone',
    'rhinoceros',
    'rhubarb',
    'rhythm',
    'ribbon',
    'rice',
    'rickshaw',
    'riddle',
    'river',
    'road',
    'robin',
    'robot',
    'rock',
    'rocket',
    'rodent',
    'roll',
    'roof',
    'room',
    'root',
    'rope',
    'rose',
    'rosemary',
    'rotunda',
    'rouge',
    'rowboat',
    'rubber',
    'ruby',
    'rudder',
    'rug',
    'ruler',
    'runner',
    'rush',
    'rutabaga',
    'sack',
    'saddle',
    'safari',
    'saffron',
    'sage',
    'sail',
    'sailboat',
    'sailor',
    'salad',
    'salamander',
    'salmon',
    'salon',
    'salt',
    'sanctuary',
    'sand',
    'sandal',
    'sandpiper',
    'sandwich',
    'sapphire',
    'sardine',
    'sash',
    'satellite',
    'satin',
    'sauce',
    'saucer',
    'sauna',
    'savanna',
    'saxophone',
    'scale',
    'scallion',
    'scallop',
    'scanner',
    'scarf',
    'scenario',
    'scene',
    'scenery',
    'scent',
    'school',
    'science',
    'scissors',
    'scone',
    'scooter',
    'scorpion',
    'scout',
    'scrap',
    'screen',
    'screwdriver',
    'scrub',
    'sculpture',
    'sea',
    'seagull',
    'seal',
    'seaplane',
    'seashell',
    'seaweed',
    'sedan',
    'seed',
    'seeker',
    'segment',
    'selenium',
    'semicircle',
    'sequoia',
    'serum',
    'sesame',
    'shack',
    'shade',
    'shadow',
    'shaft',
    'shallot',
    'shampoo',
    'shark',
    'shawl',
    'shed',
    'sheep',
    'sheet',
    'shelf',
    'shell',
    'shelter',
    'shield',
    'ship',
    'shirt',
    'shoe',
    'shop',
    'shore',
    'shovel',
    'shower',
    'shrimp',
    'shrub',
    'shutter',
    'shuttle',
    'sidecar',
    'sidewalk',
    'sieve',
    'signal',
    'silicon',
    'silk',
    'sill',
    'silver',
    'silverware',
    'simulation',
    'singer',
    'siren',
    'site',
    'skate',
    'skeleton',
    'sketch',
    'ski',
    'skiff',
    'skill',
    'sky',
    'slab',
    'slate',
    'sled',
    'sleeve',
    'sleet',
    'slide',
    'slipper',
    'slope',
    'slug',
    'slumber',
    'smile',
    'snack',
    'snail',
    'snake',
    'snapshot',
    'sneeze',
    'snow',
    'snowflake',
    'soap',
    'soccer',
    'socks',
    'soda',
    'sofa',
    'soil',
    'solvent',
    'sorbet',
    'sound',
    'soup',
    'soy',
    'soybean',
    'space',
    'spaceship',
    'spade',
    'spaghetti',
    'spark',
    'sparrow',
    'spatula',
    'speaker',
    'spear',
    'spectrum',
    'spice',
    'spider',
    'spinach',
    'spiral',
    'sponge',
    'spoon',
    'spray',
    'spring',
    'sprinkler',
    'sprout',
    'spruce',
    'square',
    'squash',
    'squid',
    'squirrel',
    'stable',
    'stadium',
    'stage',
    'staircase',
    'stamen',
    'star',
    'starch',
    'starfish',
    'starling',
    'station',
    'statue',
    'steam',
    'steel',
    'stem',
    'stencil',
    'step',
    'stereo',
    'stick',
    'sticker',
    'stilts',
    'stitch',
    'stone',
    'storm',
    'story',
    'stove',
    'straw',
    'strawberry',
    'stream',
    'street',
    'string',
    'structure',
    'studio',
    'subway',
    'succulent',
    'sugar',
    'sulfur',
    'summer',
    'summit',
    'sun',
    'sunflower',
    'sunset',
    'sunshine',
    'supermarket',
    'surf',
    'sushi',
    'swallow',
    'swan',
    'sweater',
    'swift',
    'swing',
    'switch',
    'sycamore',
    'symphony',
    'syrup',
    'system',
    'table',
    'tablecloth',
    'tablet',
    'taco',
    'tadpole',
    'taffy',
    'tail',
    'tambourine',
    'tangerine',
    'tank',
    'tape',
    'tapioca',
    'tapir',
    'target',
    'taxi',
    'tea',
    'teacup',
    'teapot',
    'technology',
    'teddy',
    'telephone',
    'telescope',
    'television',
    'temple',
    'tempo',
    'tennis',
    'tenor',
    'tent',
    'termite',
    'terrace',
    'territory',
    'texture',
    'theater',
    'thistle',
    'thimble',
    'thread',
    'threshold',
    'throne',
    'thyme',
    'ticket',
    'tide',
    'tiger',
    'tile',
    'timber',
    'time',
    'timeline',
    'tin',
    'tint',
    'toast',
    'toffee',
    'tofu',
    'tomato',
    'tool',
    'topaz',
    'tornado',
    'tortoise',
    'toucan',
    'tower',
    'town',
    'toy',
    'tractor',
    'traffic',
    'trail',
    'train',
    'tram',
    'trampoline',
    'transport',
    'trapeze',
    'travel',
    'tray',
    'treasure',
    'tree',
    'treehouse',
    'trellis',
    'triangle',
    'tricycle',
    'trolley',
    'trombone',
    'trophy',
    'trout',
    'truck',
    'trumpet',
    'trunk',
    'tulip',
    'tumbleweed',
    'tuna',
    'tunnel',
    'turkey',
    'turnip',
    'turtle',
    'tusk',
    'tuxedo',
    'twig',
    'twilight',
    'typhoon',
    'umbrella',
    'unicorn',
    'universe',
    'university',
    'vacuum',
    'valley',
    'vanilla',
    'vapor',
    'vase',
    'vault',
    'vegetable',
    'vegetation',
    'vehicle',
    'velvet',
    'vendor',
    'veneer',
    'vent',
    'venus',
    'vessel',
    'vest',
    'video',
    'vine',
    'vinegar',
    'vinyl',
    'viola',
    'violin',
    'viper',
    'vitamin',
    'volcano',
    'voyage',
    'wafer',
    'wagon',
    'wake',
    'walk',
    'wall',
    'wallet',
    'walnut',
    'walrus',
    'wand',
    'warehouse',
    'wardrobe',
    'warmth',
    'wasabi',
    'water',
    'waterfall',
    'watermelon',
    'wave',
    'wax',
    'weasel',
    'weather',
    'web',
    'website',
    'wedge',
    'weekend',
    'weight',
    'well',
    'whale',
    'wheat',
    'wheel',
    'whippet',
    'whirlpool',
    'whisker',
    'whistle',
    'wilderness',
    'willow',
    'wind',
    'window',
    'wine',
    'wing',
    'winter',
    'wire',
    'wisdom',
    'wisteria',
    'witch',
    'wizard',
    'wok',
    'wolf',
    'wolverine',
    'wood',
    'wool',
    'world',
    'wreath',
    'wrench',
    'xenon',
    'yacht',
    'yak',
    'yard',
    'yarn',
    'year',
    'yogurt',
    'yolk',
    'zebra',
    'zenith',
    'zephyr',
    'zero',
    'zest',
    'zinc',
    'zipper',
    'zone',
    'zoom',
    'zucchini',
  ],
  verbs: [
    'accept',
    'accomplish',
    'achieve',
    'acquire',
    'act',
    'adapt',
    'add',
    'address',
    'adjust',
    'admire',
    'admit',
    'adopt',
    'adore',
    'advance',
    'advise',
    'affirm',
    'aid',
    'aim',
    'alert',
    'align',
    'allow',
    'alter',
    'amaze',
    'amend',
    'amplify',
    'analyze',
    'animate',
    'announce',
    'answer',
    'anticipate',
    'appear',
    'applaud',
    'apply',
    'appoint',
    'appreciate',
    'approach',
    'approve',
    'archive',
    'argue',
    'arise',
    'arrange',
    'arrive',
    'articulate',
    'ask',
    'assemble',
    'assert',
    'assess',
    'assist',
    'assume',
    'assure',
    'attach',
    'attain',
    'attend',
    'attract',
    'audit',
    'augment',
    'author',
    'authorize',
    'automate',
    'award',
    'balance',
    'bake',
    'bathe',
    'beam',
    'beckon',
    'begin',
    'behave',
    'believe',
    'belong',
    'bend',
    'benefit',
    'blink',
    'bloom',
    'blossom',
    'board',
    'boast',
    'boil',
    'book',
    'boost',
    'borrow',
    'bounce',
    'bow',
    'breathe',
    'brew',
    'brighten',
    'bring',
    'broadcast',
    'browse',
    'brush',
    'bubble',
    'budget',
    'build',
    'bump',
    'calculate',
    'call',
    'calm',
    'camp',
    'cancel',
    'capture',
    'care',
    'carry',
    'carve',
    'cast',
    'catalog',
    'catch',
    'categorize',
    'celebrate',
    'center',
    'challenge',
    'change',
    'channel',
    'chart',
    'chase',
    'chat',
    'check',
    'cheer',
    'cherish',
    'chew',
    'choose',
    'circle',
    'cite',
    'claim',
    'clarify',
    'classify',
    'clean',
    'clear',
    'click',
    'climb',
    'cling',
    'close',
    'coach',
    'code',
    'coexist',
    'collaborate',
    'collect',
    'color',
    'combine',
    'comfort',
    'command',
    'commence',
    'comment',
    'commit',
    'communicate',
    'compare',
    'compile',
    'complete',
    'compose',
    'compute',
    'conceive',
    'concentrate',
    'conclude',
    'conduct',
    'confess',
    'configure',
    'confirm',
    'connect',
    'consider',
    'consist',
    'construct',
    'consult',
    'contain',
    'continue',
    'contribute',
    'control',
    'convert',
    'convey',
    'cook',
    'cool',
    'cooperate',
    'coordinate',
    'copy',
    'correct',
    'correspond',
    'counsel',
    'count',
    'craft',
    'create',
    'credit',
    'critique',
    'cross',
    'cruise',
    'cuddle',
    'cultivate',
    'cure',
    'curl',
    'customize',
    'cycle',
    'dance',
    'dazzle',
    'deal',
    'debate',
    'decide',
    'decorate',
    'decrease',
    'dedicate',
    'define',
    'delay',
    'delegate',
    'delight',
    'deliver',
    'demonstrate',
    'depend',
    'depict',
    'deposit',
    'derive',
    'describe',
    'design',
    'desire',
    'detail',
    'detect',
    'determine',
    'develop',
    'devise',
    'diagnose',
    'dial',
    'differ',
    'digest',
    'direct',
    'disappear',
    'discover',
    'discuss',
    'display',
    'distinguish',
    'distribute',
    'dive',
    'divert',
    'divide',
    'document',
    'donate',
    'download',
    'draft',
    'draw',
    'dream',
    'drift',
    'drink',
    'drive',
    'drop',
    'dry',
    'dwell',
    'earn',
    'ease',
    'eat',
    'echo',
    'edit',
    'educate',
    'elaborate',
    'elect',
    'elevate',
    'eliminate',
    'embark',
    'embrace',
    'emerge',
    'emphasize',
    'employ',
    'empower',
    'enable',
    'enact',
    'enchant',
    'encounter',
    'encourage',
    'endorse',
    'endure',
    'energize',
    'enforce',
    'engage',
    'engineer',
    'enhance',
    'enjoy',
    'enlist',
    'enliven',
    'enrich',
    'enter',
    'entertain',
    'enthuse',
    'entrust',
    'enumerate',
    'envision',
    'equalize',
    'equip',
    'erase',
    'erect',
    'escape',
    'establish',
    'estimate',
    'evaluate',
    'evolve',
    'examine',
    'exceed',
    'excel',
    'exchange',
    'excite',
    'exclude',
    'excuse',
    'execute',
    'exercise',
    'exhale',
    'exhibit',
    'exist',
    'expand',
    'expect',
    'expedite',
    'experiment',
    'explain',
    'explore',
    'export',
    'express',
    'extend',
    'extract',
    'face',
    'facilitate',
    'fade',
    'fail',
    'fancy',
    'fascinate',
    'fasten',
    'favor',
    'feature',
    'feed',
    'feel',
    'fetch',
    'filter',
    'finalize',
    'finance',
    'find',
    'finish',
    'fit',
    'fix',
    'flap',
    'flash',
    'flatten',
    'flavor',
    'flex',
    'float',
    'flourish',
    'flow',
    'flutter',
    'focus',
    'fold',
    'follow',
    'forecast',
    'forge',
    'form',
    'formulate',
    'foster',
    'found',
    'frame',
    'free',
    'freeze',
    'freshen',
    'fulfill',
    'function',
    'furnish',
    'further',
    'fuse',
    'gain',
    'gallop',
    'garden',
    'garner',
    'gather',
    'gaze',
    'generate',
    'gesture',
    'get',
    'give',
    'glance',
    'gleam',
    'glide',
    'glow',
    'go',
    'govern',
    'grab',
    'graduate',
    'grant',
    'grasp',
    'greet',
    'grill',
    'grip',
    'groom',
    'ground',
    'grow',
    'guarantee',
    'guard',
    'guess',
    'guide',
    'handle',
    'hang',
    'happen',
    'harmonize',
    'harvest',
    'hasten',
    'hatch',
    'heal',
    'hear',
    'heat',
    'help',
    'hesitate',
    'hide',
    'highlight',
    'hike',
    'hinder',
    'hint',
    'hire',
    'hit',
    'hoist',
    'hold',
    'honor',
    'hook',
    'hope',
    'host',
    'hover',
    'hug',
    'hum',
    'hunt',
    'hurry',
    'identify',
    'ignite',
    'illuminate',
    'illustrate',
    'imagine',
    'imitate',
    'immerse',
    'implement',
    'imply',
    'import',
    'impress',
    'improve',
    'include',
    'incorporate',
    'increase',
    'incubate',
    'indicate',
    'induce',
    'inform',
    'infuse',
    'inhabit',
    'initiate',
    'inject',
    'innovate',
    'inquire',
    'insert',
    'inspect',
    'inspire',
    'install',
    'institute',
    'instruct',
    'insulate',
    'integrate',
    'intend',
    'intensify',
    'interact',
    'interest',
    'interfere',
    'interject',
    'interpret',
    'interrupt',
    'interview',
    'introduce',
    'invent',
    'invest',
    'investigate',
    'invite',
    'involve',
    'isolate',
    'issue',
    'itemize',
    'iterate',
    'join',
    'joke',
    'journey',
    'judge',
    'juggle',
    'jump',
    'justify',
    'keep',
    'kindle',
    'knead',
    'knit',
    'know',
    'label',
    'land',
    'launch',
    'layer',
    'lead',
    'lean',
    'leap',
    'learn',
    'leave',
    'lecture',
    'lend',
    'level',
    'license',
    'lift',
    'light',
    'like',
    'limit',
    'line',
    'link',
    'list',
    'listen',
    'live',
    'load',
    'locate',
    'lock',
    'log',
    'long',
    'look',
    'loop',
    'lose',
    'love',
    'lower',
    'maintain',
    'make',
    'manage',
    'maneuver',
    'manipulate',
    'manufacture',
    'map',
    'march',
    'mark',
    'market',
    'marvel',
    'match',
    'matter',
    'mature',
    'maximize',
    'mean',
    'measure',
    'mediate',
    'meditate',
    'meet',
    'melt',
    'memorize',
    'mend',
    'mention',
    'mentor',
    'merge',
    'message',
    'migrate',
    'mind',
    'minimize',
    'mix',
    'model',
    'moderate',
    'modernize',
    'modify',
    'moisturize',
    'monitor',
    'motivate',
    'mount',
    'move',
    'multiply',
    'murmur',
    'muse',
    'name',
    'narrate',
    'navigate',
    'need',
    'negotiate',
    'nest',
    'nod',
    'nominate',
    'normalize',
    'note',
    'notice',
    'notify',
    'nourish',
    'nudge',
    'nurture',
    'obey',
    'object',
    'observe',
    'obtain',
    'occupy',
    'occur',
    'offer',
    'offset',
    'open',
    'operate',
    'optimize',
    'orchestrate',
    'order',
    'organize',
    'orient',
    'originate',
    'outline',
    'output',
    'overcome',
    'overlap',
    'oversee',
    'overtake',
    'pace',
    'pack',
    'paddle',
    'paint',
    'pair',
    'park',
    'participate',
    'pass',
    'paste',
    'patch',
    'pause',
    'pay',
    'pedal',
    'peek',
    'peel',
    'perceive',
    'perfect',
    'perform',
    'permit',
    'persist',
    'persuade',
    'phone',
    'photograph',
    'pick',
    'pilot',
    'pivot',
    'place',
    'plan',
    'plant',
    'play',
    'pledge',
    'plot',
    'pluck',
    'point',
    'polish',
    'ponder',
    'pose',
    'position',
    'post',
    'pour',
    'practice',
    'praise',
    'preach',
    'precede',
    'predict',
    'prefer',
    'prepare',
    'present',
    'preserve',
    'preside',
    'press',
    'prevent',
    'preview',
    'print',
    'process',
    'proclaim',
    'produce',
    'profess',
    'program',
    'progress',
    'project',
    'promise',
    'promote',
    'prompt',
    'proofread',
    'propose',
    'protect',
    'provide',
    'publish',
    'pull',
    'pump',
    'purchase',
    'purify',
    'pursue',
    'push',
    'qualify',
    'quantify',
    'question',
    'queue',
    'quicken',
    'quiet',
    'quiz',
    'quote',
    'race',
    'radiate',
    'raise',
    'rally',
    'rank',
    'rate',
    'reach',
    'react',
    'read',
    'realize',
    'rearrange',
    'reason',
    'rebuild',
    'recall',
    'receive',
    'recite',
    'recognize',
    'recommend',
    'reconcile',
    'record',
    'recover',
    'recruit',
    'recycle',
    'reduce',
    'refer',
    'refine',
    'reflect',
    'reform',
    'refresh',
    'refund',
    'refuse',
    'regard',
    'register',
    'regulate',
    'rehearse',
    'reign',
    'reinforce',
    'reject',
    'rejoice',
    'relate',
    'relax',
    'release',
    'relieve',
    'relinquish',
    'rely',
    'remain',
    'remember',
    'remind',
    'remove',
    'render',
    'renew',
    'renovate',
    'repair',
    'repeat',
    'replace',
    'reply',
    'report',
    'represent',
    'request',
    'require',
    'rescue',
    'research',
    'resemble',
    'reserve',
    'reset',
    'reside',
    'resign',
    'resist',
    'resolve',
    'resonate',
    'respect',
    'respond',
    'rest',
    'restore',
    'restructure',
    'result',
    'resume',
    'retain',
    'retire',
    'retreat',
    'return',
    'reveal',
    'review',
    'revise',
    'revive',
    'revolve',
    'rewrite',
    'ride',
    'ring',
    'rinse',
    'rise',
    'risk',
    'roam',
    'roast',
    'rock',
    'roll',
    'rotate',
    'rouse',
    'row',
    'rub',
    'rule',
    'run',
    'rush',
    'sail',
    'salute',
    'sample',
    'satisfy',
    'save',
    'savor',
    'say',
    'scale',
    'scan',
    'scatter',
    'schedule',
    'school',
    'score',
    'scout',
    'scrape',
    'scratch',
    'screen',
    'scribble',
    'scroll',
    'scrub',
    'sculpt',
    'search',
    'season',
    'seat',
    'secure',
    'see',
    'seek',
    'select',
    'sell',
    'send',
    'sense',
    'separate',
    'sequence',
    'serve',
    'set',
    'settle',
    'sew',
    'shade',
    'shake',
    'shape',
    'share',
    'sharpen',
    'shave',
    'shelter',
    'shift',
    'shine',
    'ship',
    'shock',
    'shop',
    'shorten',
    'show',
    'shower',
    'shuffle',
    'shut',
    'sift',
    'sigh',
    'sign',
    'signal',
    'simplify',
    'simulate',
    'sing',
    'sip',
    'sit',
    'sketch',
    'ski',
    'skip',
    'sleep',
    'slice',
    'slide',
    'slip',
    'slow',
    'smell',
    'smile',
    'smooth',
    'soak',
    'soar',
    'socialize',
    'soften',
    'solve',
    'sort',
    'sound',
    'sow',
    'sparkle',
    'speak',
    'specify',
    'speed',
    'spell',
    'spend',
    'spice',
    'spin',
    'spiral',
    'splash',
    'splice',
    'split',
    'sponsor',
    'spot',
    'spray',
    'spread',
    'spring',
    'sprinkle',
    'sprout',
    'squeeze',
    'stabilize',
    'stack',
    'stage',
    'stain',
    'stamp',
    'stand',
    'star',
    'start',
    'state',
    'stay',
    'steer',
    'step',
    'stick',
    'stimulate',
    'stir',
    'stitch',
    'stop',
    'store',
    'straighten',
    'strain',
    'streamline',
    'strengthen',
    'stretch',
    'stride',
    'strike',
    'string',
    'strip',
    'strive',
    'stroke',
    'structure',
    'study',
    'stuff',
    'stumble',
    'stun',
    'submit',
    'subscribe',
    'succeed',
    'suck',
    'suggest',
    'suit',
    'summarize',
    'summon',
    'supply',
    'support',
    'suppose',
    'surface',
    'surge',
    'surprise',
    'surrender',
    'surround',
    'survey',
    'survive',
    'suspend',
    'sustain',
    'swallow',
    'swap',
    'sway',
    'sweep',
    'swell',
    'swim',
    'swing',
    'switch',
    'symbolize',
    'synchronize',
    'synthesize',
    'tabulate',
    'tag',
    'take',
    'talk',
    'tame',
    'tap',
    'target',
    'taste',
    'teach',
    'team',
    'tear',
    'tease',
    'tell',
    'tempt',
    'tend',
    'test',
    'thank',
    'thaw',
    'think',
    'thrive',
    'throw',
    'tickle',
    'tidy',
    'tie',
    'tilt',
    'time',
    'tinker',
    'tip',
    'toast',
    'toggle',
    'tolerate',
    'tone',
    'touch',
    'tour',
    'tow',
    'trace',
    'track',
    'trade',
    'train',
    'transcribe',
    'transfer',
    'transform',
    'translate',
    'transmit',
    'transport',
    'trap',
    'travel',
    'tread',
    'treasure',
    'treat',
    'trim',
    'trip',
    'triumph',
    'trust',
    'try',
    'tug',
    'tumble',
    'tune',
    'turn',
    'tutor',
    'twist',
    'type',
    'uncover',
    'undergo',
    'understand',
    'undertake',
    'undo',
    'unfold',
    'unify',
    'unite',
    'unlock',
    'unpack',
    'update',
    'upgrade',
    'uphold',
    'upload',
    'use',
    'utter',
    'vacuum',
    'validate',
    'value',
    'vanish',
    'vary',
    'vault',
    'verify',
    'view',
    'visit',
    'visualize',
    'vocalize',
    'voice',
    'volunteer',
    'vote',
    'voyage',
    'wade',
    'wait',
    'wake',
    'walk',
    'wander',
    'want',
    'warm',
    'warn',
    'wash',
    'watch',
    'water',
    'wave',
    'wear',
    'weave',
    'wed',
    'weigh',
    'welcome',
    'whip',
    'whisper',
    'whistle',
    'win',
    'wind',
    'wink',
    'wipe',
    'wish',
    'withdraw',
    'witness',
    'wobble',
    'wonder',
    'work',
    'worry',
    'wrap',
    'wrench',
    'wrestle',
    'wriggle',
    'write',
    'yawn',
    'yield',
    'yodel',
    'zoom',
  ],
}
